<template>
  <div class="step-nav">
    <div class="step-nav__inner">
      <div class="step-nav__button-outer step-nav__button-outer--left">
        <transition name="animation-fade">
          <button
            class="step-nav__button step-nav__button--prev step-nav__button--loading step-nav__button--left"
            v-show="pageLoading">
            <span class="position-r"><i class="fas fa-spinner fa-spin"></i></span>
          </button>
        </transition>

        <transition name="animation-fade">
          <button
            class="step-nav__button step-nav__button--prev step-nav__button--left"
            @click="prevButtonClick()"
            v-show="!pageLoading">
            <span class="position-r">戻る</span>
          </button>
        </transition>
      </div>

      <div class="step-nav__button-outer step-nav__button-outer--right">
        <transition name="animation-fade">
          <button
            class="step-nav__button step-nav__button--next step-nav__button--loading step-nav__button--right"
            v-show="pageLoading || !currentPage">
            <span class="position-r"><i class="fas fa-spinner fa-spin"></i></span>
          </button>
        </transition>

        <div v-show="!pageLoading">
          <transition name="animation-fade">
            <button
              class="step-nav__button step-nav__button--next step-nav__button--right"
              v-show="
                currentPage && !currentPage.required ||
                selectItem && !selectItem.soldout && currentPage.slug !== 'complete'"
              @click="nextButtonClick()">
              <span class="position-r">次へ</span>
            </button>
          </transition>

          <transition name="animation-fade">
            <button
              class="step-nav__button step-nav__button--select step-nav__button--right"
              v-show="
                currentPage && currentPage.required && !selectItem && currentPage.slug !== 'complete' ||
                selectItem && selectItem.soldout"
              disabled>
              <span class="position-r">選択してください</span>
            </button>
          </transition>
        </div>
      </div>
    </div>
    <v-mobile-cart/>

    <v-prev-dialog v-model="dialog.state" message="前のページへ戻ると今まで選択した商品がリセットされます。"/>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  components: {
    'v-mobile-cart': require('@/components/mobile-cart.vue').default,
    'v-prev-dialog': require('@/components/prev-dialog.vue').default,
  },
  computed: {
    ...mapState({
      prevPage: state => state.step.prev,
      currentPage: state => state.step.current,
      nextPage: state => state.step.next,
      selectItem: state => state.step.selectItem,
      windowWidth: state => state.window.width,
      pageLoading: state => state.page.loading,
    })
  },
  data() {
    return {
      next: {
        state: false,
      },
      select: {
        state: true,
      },
      cart: {
        state: false,
      },
      dialog: {
        state: false,
      },
      nextPageData: {},
    }
  },
  methods: {
    prevButtonClick() {
      let root = this.$route.path.match(/gogatsu/) ?  this.config.path.root_gogatsu : this.config.path.root;

      if (!this.prevPage || this.currentPage.slug === 'sizes') {
        this.$store.commit('canvas/itemsReset')
        this.$store.commit('cart/itemsReset')
        this.$router.push({
          path: root,
          query: null,
        })
        return
      }

      this.$store.commit('page/loading', true)
      let path = root + '/step/' + this.prevPage.slug + '/' + this.prevPage.order
      let query = Object.assign({}, this.$route.query)

      if (this.currentPage.slug === 'stages') {
        this.dialog.state = true
      } else {
        this.$router.push({
          path: path,
          query: query,
        })
      }
    },
    nextButtonClick() {
      this.$store.commit('page/loading', true)
      this.nextPageGet()
    },
    nextPageGet() {
      let apiURL
      if (this.config.debug) {
        apiURL = '/index_dev.php/api/choice/next'
      } else {
        apiURL = '/api/choice/next'
      }

      axios.get(apiURL + '?order=' + this.$route.params.order, {
          params: this.$route.query
        })
        .then(response => {
          console.log('next page response')
          console.log(response.data)

          this.nextPageData = response.data
          let step = {
            next: response.data,
          }
          this.$store.commit('step/stepSet', step)
          this.nextPageTransition()
        })
        .catch((error) => {
          console.log(error)
          let payload = {
            status: error.response.status,
            code: this.config.errorCode.nextPage + '' + error.response.status,
            message: 'エラーが発生しました。',
          }
          this.$store.commit('error/errorSet', payload)
        })
    },
    nextPageTransition() {
      let order = this.nextPageData.order
      let root = this.$route.path.match(/gogatsu/) ?  this.config.path.root_gogatsu : this.config.path.root;
      order = String(order)
      order = order.replace('.', '-')
      let path = root + '/step/' + this.nextPageData.slug + '/' + order
      let query = Object.assign({}, this.$route.query)

      this.$router.push({
        path: path,
        query: query,
      })
    },
  },
}
</script>



<style lang="scss">
.step-nav {
  $e: &;
  touch-action: manipulation;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: map-get($z-index, 'step-nav-mobile');
  width: 100%;
  height: 76px;
  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    z-index: 1;
    transform: translateX(-50%);
    background: url(/choice/img/common/step-nav-mobile-bg-center.png) center bottom / 100px 76px no-repeat;
    width: 100px;
    height: 76px;
  }
  @include breakpoints-min(lg) {
    display: flex;
    justify-content: center;
    position: static;
    background-color: #fff;
    text-align: center;
    width: auto;
    height: auto;
    &::before {
      display: none;
    }
  }

  &__inner {
    position: relative;
    &::before,
    &::after {
      content: "";
      display: block;
      position: absolute;
      z-index: 1;
      background: url(/choice/img/common/step-nav-mobile-bg.png) center bottom / 5px 76px repeat-x;
      width: 50%;
      height: 76px;
    }
    &::before {
      left: -50px;
      @include breakpoints-min(lg) {
        top: 0;
        left: 0;
        background: linear-gradient(to right, transparent 0%, #947c72 40%, #947c72 60%, transparent 100%);
        width: 100%;
        height: 1px;
      }
    }
    &::after {
      right: -50px;
      @include breakpoints-min(lg) {
        display: none;
      }
    }
    @include breakpoints-min(lg) {
      display: flex;
      justify-content: center;
      transition: $transition;
      position: relative;
      background-color: #fff;
      width: $col-width * 2 + 64;
      padding-top: 24px;
      padding-bottom: 24px;
    }
  }
  &__button-outer {
    position: relative;
    z-index: 2;
    @include breakpoints-min(lg) {
      overflow: hidden;
      border-radius: 99px;
      width: 192px;
      height: 50px;
      margin-top: 0;
      &::before,
      &::after {
        display: none;
      }
      & + & {
        margin-left: 24px;
      }
    }
    &--left {
      &::before {
        content: "";
        display: block;
        position: absolute;
        z-index: 1;
        top: 16px;
        left: 0;
        background-color: #fff;
        width: calc(50% - 50px);
        height: 60px;
        @include breakpoints-min(lg) {
          display: none;
        }
      }
    }
    &--right {
      &::before {
        content: "";
        display: block;
        position: absolute;
        z-index: 1;
        top: 16px;
        right: 0;
        background-color: #fff;
        width: calc(50% - 50px);
        height: 60px;
        @include breakpoints-min(lg) {
          display: none;
        }
      }
    }
  }
  &__button {
    $e: &;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    display: inline-block;
    z-index: 10;
    appearance: none;
    transition: $transition;
    outline: none;
    border: none;
    background: #fff;
    font-size: 11px;
    text-align: center;
    color: $oc-gray-8;
    &:disabled {
      cursor: no-drop;
    }
    @include breakpoints-min(sm) {
      font-size: 12px;
    }

    &--left,
    &--right {
      position: absolute;
      top: 5px;
      border-radius: 99px;
      line-height: 42px;
      letter-spacing: 0.25em;
      color: #fff;
      width: 152px;
      height: 50px;
      margin-top: 16px;
      @include breakpoints-min(sm) {
        width: 192px;
      }
      @include breakpoints-min(lg) {
        top: 0;
        margin-top: 0;
      }
      &::after{
        content: "";
        display: block;
        transition: $transition;
        position: absolute;
        top: 50%;
        width: 7px;
        height: 7px;
        @include breakpoints-min(lg) {
          top: 50%;
        }
      }
    }

    &--left {
      left: calc(25% - 12px);
      transform: translateX(-50%);
      padding-left: 12px;
      .position-r {
        margin-right: 0;
      }
      @include breakpoints-min(lg) {
        left: 0;
        transform: none;
        border-right: none;
        .position-r {
          margin-right: 0;
        }
      }
      &::after {
        left: 16px;
        border-top: 2px solid $oc-gray-7;
        border-left: 2px solid $oc-gray-7;
        transform: translateY(-50%) rotate(-45deg);
        @include breakpoints-min(sm) {
          left: 26px;
        }
      }
    }
    &--right {
      right: calc(25% - 12px);
      transform: translateX(50%);
      padding-right: 12px;
      .position-r {
        margin-left: 0;
      }
      @include breakpoints-min(lg) {
        right: 0;
        transform: none;
        border-left: none;
        .position-r {
          margin-left: 0;
        }
      }
      &::after {
        right: 16px;
        border-top: 2px solid $oc-gray-7;
        border-right: 2px solid $oc-gray-7;
        transform: translateY(-50%) rotate(45deg);
        border-color: #fff;
        @include breakpoints-min(sm) {
          right: 26px;
        }
      }
    }

    &--prev {
      border: 1px solid $oc-gray-4;
      background-color: #fff;
      color: $oc-gray-8;
      &::after {
        border-color: $oc-gray-8;
      }
      @include hover() {
        border: 1px solid $accent-color;
        color: $accent-color;
        &::after {
          @include breakpoints-min(lg) {
            border-color: $accent-color;
          }
        }
      }
      @include active() {
        border: 1px solid $accent-color;
        background-color: $accent-color-bg;
      }
      &:disabled {
        color: $oc-gray-5;
        &::after {
          border-color: $oc-gray-5;
        }
      }
    }
    &--next {
      border: 1px solid $accent-color;
      background-color: $accent-color;
      &::after {
        border-color: #fff;
      }
      @include hover() {
        border: 1px solid $accent-color-hover;
        background-color: $accent-color-hover;
      }
      @include active() {
        border: 1px solid $accent-color-active;
        background-color: $accent-color-active;
        color: #fff;
      }
    }
    &--select {
      border: 1px solid $accent-color-disabled;
      background-color: $accent-color-disabled;
      letter-spacing: 0.1em;
      color: #fff;
    }
    &--loading {
      cursor: no-drop;
    }
  }

  .mobile-cart {
    position: absolute;
    top: 16px;
    left: 50%;
    z-index: 10;
    transform: translate(-50%, -50%);
    @include breakpoints-min(lg) {
      display: none;
    }
  }
}

.app-gogatsu {
    .step-nav {
        $e: &;

        &__button {
            $e: &;
            
            &--prev {
                border: 1px solid $oc-gray-4;
                background-color: #fff;
                color: $oc-gray-8;
                &::after {
                    border-color: $oc-gray-8;
                }
                @include hover() {
                    border: 1px solid $gogatsu-accent-color;
                    color: $gogatsu-accent-color;
                    &::after {
                        @include breakpoints-min(lg) {
                            border-color: $gogatsu-accent-color;
                        }
                    }
                }
                @include active() {
                    border: 1px solid $gogatsu-accent-color;
                    background-color: $gogatsu-accent-color-bg;
                }
                &:disabled {
                    color: $oc-gray-5;
                    &::after {
                        border-color: $oc-gray-5;
                    }
                }
            }
            &--next {
                border: 1px solid $gogatsu-accent-color;
                background-color: $gogatsu-accent-color;
                &::after {
                    border-color: #fff;
                }
                @include hover() {
                    border: 1px solid $gogatsu-accent-color-hover;
                    background-color: $gogatsu-accent-color-hover;
                }
                @include active() {
                    border: 1px solid $gogatsu-accent-color-active;
                    background-color: $gogatsu-accent-color-active;
                    color: #fff;
                }
            }
            &--select {
                border: 1px solid $gogatsu-accent-color-disabled;
                background-color: $gogatsu-accent-color-disabled;
                letter-spacing: 0.1em;
                color: #fff;
            }
        }
    }
    
}
</style>
